import { fetchLastNews } from '../api';
import { prepareLastNewsList } from './last-news-list';
import { Env } from '@/shared/config/environment';

const state = {
  newsList: [],
  lastNewsList: null,
  isLoadingNews: false,
  newsError: null,
};

const mutations = {
  SET_NEWS_LIST(state, newsList) {
    state.newsList = newsList;
  },
  SET_LOADING_NEWS(state, isLoading) {
    state.isLoadingNews = isLoading;
  },
  SET_NEWS_ERROR(state, error) {
    state.newsError = error;
  },
  SET_LAST_NEWS_LIST(state, newsList) {
    state.lastNewsList = newsList;
  },
};

const actions = {
  async fetchLastNews({ commit, dispatch }) {
    commit('SET_LOADING_NEWS', true);
    commit('SET_NEWS_ERROR', null);
    commit('SET_NEWS_LIST', []);

    try {
      const news = await fetchLastNews();
      commit('SET_NEWS_LIST', news);

      const lastNewsList = prepareLastNewsList(news);
      commit('SET_LAST_NEWS_LIST', lastNewsList);
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося отримати останні новини';

      commit('SET_NEWS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити останні новини',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_NEWS', false);
    }
  },
};

const getters = {
  isLoadingNews: (state) => state.isLoadingNews,
  newsError: (state) => state.newsError,
  isNewsDataReady: (state) => state.isLoadingNews === false && state.lastNewsList !== null,
  isEmpty: (state) => state?.lastNewsList?.length === 0,
  getNewsList: (state) => state.lastNewsList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
